// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2vqeZ","itemTitle":"ClientEmergencyInfo_itemTitle__2XGgW","itemText":"ClientEmergencyInfo_itemText__3n752"};